import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_NO_PURCHASES_PARENTS_REPORT,
  GET_NO_PURCHASES_STUDENTS_REPORT,
  GET_NO_SUBSCRIPTION_PARENTS_REPORT,
  GET_NO_SUBSCRIPTION_STUDENTS_REPORT,
  GetNoPurchasesParentsReportAction,
  GetNoPurchasesStudentsReportAction,
  GetNoSubscriptionParentsReportAction,
  GetNoSubscriptionStudentsReportAction,
} from "./actionTypes";
import {
  getNoPurchasesParentsReportError,
  getNoPurchasesParentsReportSuccess,
  getNoPurchasesStudentsReportError,
  getNoPurchasesStudentsReportSuccess,
  getNoSubscriptionParentsReportError,
  getNoSubscriptionParentsReportSuccess,
  getNoSubscriptionStudentsReportError,
  getNoSubscriptionStudentsReportSuccess,
} from "./actions";
import { ResponseGenerator } from "../../interfaces";
import {
  getNoPurchasesParentsReport,
  getNoPurchasesStudentsReport,
  getNoSubscriptionParentsReport,
  getNoSubscriptionStudentsReport,
} from "../../helpers/backend_helper";

function* getNoPurchasesStudentsReportSaga({}: GetNoPurchasesStudentsReportAction) {
  try {
    const response: ResponseGenerator = yield call(
      getNoPurchasesStudentsReport
    );
    yield put(getNoPurchasesStudentsReportSuccess(response.data));
  } catch (error) {
    yield put(getNoPurchasesStudentsReportError(error));
  }
}

function* getNoPurchasesParentsReportSaga({}: GetNoPurchasesParentsReportAction) {
  try {
    const response: ResponseGenerator = yield call(getNoPurchasesParentsReport);
    yield put(getNoPurchasesParentsReportSuccess(response.data));
  } catch (error) {
    yield put(getNoPurchasesParentsReportError(error));
  }
}

function* getNoSubscriptionStudentsReportSaga({}: GetNoSubscriptionStudentsReportAction) {
  try {
    const response: ResponseGenerator = yield call(
      getNoSubscriptionStudentsReport
    );
    yield put(getNoSubscriptionStudentsReportSuccess(response.data));
  } catch (error) {
    yield put(getNoSubscriptionStudentsReportError(error));
  }
}

function* getNoSubscriptionParentsReportSaga({}: GetNoSubscriptionParentsReportAction) {
  try {
    const response: ResponseGenerator = yield call(
      getNoSubscriptionParentsReport
    );
    yield put(getNoSubscriptionParentsReportSuccess(response.data));
  } catch (error) {
    yield put(getNoSubscriptionParentsReportError(error));
  }
}

function* ReportSaga() {
  yield takeEvery(
    GET_NO_PURCHASES_STUDENTS_REPORT,
    getNoPurchasesStudentsReportSaga
  );
  yield takeEvery(
    GET_NO_PURCHASES_PARENTS_REPORT,
    getNoPurchasesParentsReportSaga
  );
  yield takeEvery(
    GET_NO_SUBSCRIPTION_STUDENTS_REPORT,
    getNoSubscriptionStudentsReportSaga
  );
  yield takeEvery(
    GET_NO_SUBSCRIPTION_PARENTS_REPORT,
    getNoSubscriptionParentsReportSaga
  );
}

export default ReportSaga;
